export default __webpack_public_path__ + "static/1599915108517-204453992054dc36925c276062fb4cfe.jpeg";